import { Action } from '@ngrx/store';
import { ExecutionPath } from '../../models/execution-path';
import { Activity, ProcessExecutionStatus } from '@ispm-shared/modules/bpmn';
import { BP_Status } from '../state';

export enum ExecutedPathActionTypes {
  UPDATE_EXECUTED_ACTIVITIES = '[Bpmn Process] Update Executed Activities',
  UPDATE_PROCESS_EXECUTION_STATUS = '[Bpmn Process] Update Process Execution Status',
  UPDATE_EXECUTION_HISTORY_PARSING_STATUS = '[Bpmn Process] Update Execution History Parsing Status',
  CLEAR_EXECUTION_HISTORY = '[Bpmn Process] Clear Execution History',
  UPDATE_EXECUTION_PATH = '[Bpmn Process] Update Execution Path',
  CLEAR_ITEMS_TO_SELECT = '[Bpmn Process] Update Items to select'
}

export class UpdateProcessExecutionStatus implements Action {
  readonly type = ExecutedPathActionTypes.UPDATE_PROCESS_EXECUTION_STATUS;
  constructor(public payload: { processExecutionStatus: ProcessExecutionStatus}) { }
}

export class UpdateExecutedActivitiesAction implements Action {
  readonly type = ExecutedPathActionTypes.UPDATE_EXECUTED_ACTIVITIES;
  constructor(public payload: { executedActivities: Activity[]}) { }
}

export class UpdateExecutionHistoryParsingStatusAction implements Action {
  readonly type = ExecutedPathActionTypes.UPDATE_EXECUTION_HISTORY_PARSING_STATUS;
  constructor(public payload: { status: BP_Status}) { }
}

export class ClearExecutionHistoryAction implements Action {
  readonly type = ExecutedPathActionTypes.CLEAR_EXECUTION_HISTORY;
}

export class UpdateExecutionPathAction implements Action {
  readonly type = ExecutedPathActionTypes.UPDATE_EXECUTION_PATH;
  constructor(public payload: { executionPath: ExecutionPath}) { }
}

export class ClearItemsToSelectAction implements Action {
  readonly type = ExecutedPathActionTypes.CLEAR_ITEMS_TO_SELECT;
}

export type ExecutedPathActions =
  UpdateProcessExecutionStatus |
  UpdateExecutedActivitiesAction |
  UpdateExecutionHistoryParsingStatusAction |
  ClearExecutionHistoryAction |
  UpdateExecutionPathAction |
  ClearItemsToSelectAction;
